// src/utils/localStorage.js

const ACCESS_KEY = "access_token";
const REFRESH_KEY = "refresh_token";
const USER_KEY = "user_info";

/* ===========================
   UTILITY FUNCTIONS
=========================== */

const safeSet = (key, value, label) => {
  try {
    if (value !== undefined && value !== null) {
      localStorage.setItem(key, value);
      console.log(`✅ [${label}] Stored:`, value);
    } else {
      console.warn(`⚠️ [${label}] No value passed`);
    }
  } catch (error) {
    console.error(`❌ [${label}] Error:`, error);
  }
};

const safeGet = (key, label) => {
  try {
    const value = localStorage.getItem(key);
    console.log(`🔎 [${label}] Value:`, value || "not found");
    return value;
  } catch (error) {
    console.error(`❌ [${label}] Error:`, error);
    return null;
  }
};

const safeRemove = (key, label) => {
  try {
    localStorage.removeItem(key);
    console.log(`🗑️ [${label}] Removed`);
  } catch (error) {
    console.error(`❌ [${label}] Error:`, error);
  }
};

/* ===========================
   ACCESS TOKEN
=========================== */

export const storeToken = (token) => safeSet(ACCESS_KEY, token, "storeToken");
export const getToken = () => safeGet(ACCESS_KEY, "getToken");
export const clearToken = () => safeRemove(ACCESS_KEY, "clearToken");

/* ===========================
   REFRESH TOKEN
=========================== */

export const storeRefreshToken = (token) =>
  safeSet(REFRESH_KEY, token, "storeRefreshToken");
export const getRefreshToken = () => safeGet(REFRESH_KEY, "getRefreshToken");
export const clearRefreshToken = () => safeRemove(REFRESH_KEY, "clearRefreshToken");

/* ===========================
   USER INFO
=========================== */

export const storeUser = (user) =>
  safeSet(USER_KEY, JSON.stringify(user), "storeUser");

export const getUser = () => {
  const u = safeGet(USER_KEY, "getUser");
  return u ? JSON.parse(u) : null;
};

export const clearUser = () => safeRemove(USER_KEY, "clearUser");

/* ===========================
   LOGOUT (CLEAR ALL)
=========================== */

export const clearAll = () => {
  try {
    console.log("🚪 [clearAll] Clearing all auth data...");
    clearToken();
    clearRefreshToken();
    clearUser();
    console.log("✅ [clearAll] All data cleared successfully!");
  } catch (error) {
    console.error("❌ [clearAll] Error:", error);
  }
};
